<script>
export default {
  props: {
    modelValue: Boolean,
    imageUrl: String,
  },
  emits: ['update:modelValue'],
};
</script>

<template>
  <b-modal
    :model-value="modelValue"
    @hide="$emit('update:modelValue', false)"
    centered
    hide-footer
    hide-header
    modal-class="image-preview-modal-wrapper"
    size="lg"
  >
    <div class="image-preview-container">
      <button
        class="image-preview-close"
        type="button"
        @click="$emit('update:modelValue', false)"
      >
        <i class="fas fa-times"></i>
      </button>
      <img
        v-if="imageUrl"
        :src="imageUrl"
        class="image-preview-img"
        alt="Preview"
      />
    </div>
  </b-modal>
</template>

<style scoped>
.image-preview-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
}

.image-preview-img {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 8px;
}

.image-preview-close {
  position: absolute;
  top: -4px;
  right: -4px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: background 0.2s;
}

.image-preview-close:hover {
  background: rgba(0, 0, 0, 0.85);
}
</style>
